import type { OnChanges } from '@angular/core';
import { ElementRef, inject, ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { SimpleChanges } from '@models/simple-changes.model';

@Component({
  selector: 'app-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.color-inherited]': 'this.colorInherit()',
  },
})
export class IconComponent implements OnChanges {
  public icon = input<string>('image-lib');
  public color = input<string>();
  public ariaLabel = input<string>();
  public size = input<number>();
  public colorInherit = input<boolean>(false);

  private elementRef = inject(ElementRef);

  public get element(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  public ngOnChanges(changes: SimpleChanges<this>): void {
    if (changes.color?.currentValue) {
      this.element.style.color = this.color();
    }

    if (changes.size?.currentValue) {
      this.element.style.width = `${this.size()}px`;
      this.element.style.height = `${this.size()}px`;
    }
  }
}
